import { render } from "./SMSConfiguration.vue?vue&type=template&id=41545fc1"
import script from "./SMSConfiguration.vue?vue&type=script&lang=js"
export * from "./SMSConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__